import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, fromEvent, merge } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  public config = environment
  public baseUrl = this.config['baseWithAPI'];
  public host = this.config['host'];
  private sharedData: any;
  sessionId: any;
  errormessage:any ='';
  language: BehaviorSubject<any> = new BehaviorSubject(null);
  verifyapifailed: BehaviorSubject<any> = new BehaviorSubject(null);
  showvideo: BehaviorSubject<any> = new BehaviorSubject(null);
  docclicked: BehaviorSubject<any> = new BehaviorSubject(null);
  cursorposition:BehaviorSubject<any> = new BehaviorSubject(null);
  isoffline:BehaviorSubject<any> = new BehaviorSubject(null);
  private backtohome: boolean = false;
  private onlineSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(navigator.onLine);
  constructor(private _http: HttpClient,) {
    this.onlineSubject = new BehaviorSubject(navigator.onLine);
    fromEvent(window, 'online').subscribe(() => this.onlineSubject.next(true));
    fromEvent(window, 'offline').subscribe(() => this.onlineSubject.next(false));
    // merge(online$, offline$).subscribe(status => {
    //   this.onlineSubject.next(status);
    // });
  }

  get isOnline(): Observable<boolean> {
    return this.onlineSubject.asObservable();
  }


  getCounterDetails() {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', '1')
    return this._http.get<any>(this.baseUrl + '/AviLeap/checkincounter/allcounterlist', { headers: headers });
  }

  adrInnerVideo(parameters, langtype?) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', '2');
    headers = headers.append('Accept-Language', langtype);
    return this._http.get(this.baseUrl + '/AviLeap/boarding-status-pax', { params: parameters, headers: headers });

  }
  gates_api(param): Observable<any>{
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    let params = new HttpParams()
    params = params.set('gate', param);
    headers = headers.append('version', '2')
    return this._http.get<any>(this.host + "/ADR/digital-twin-gatewise",{params: params, headers: headers});
  }

  setbacktohome(value){
    this.backtohome = value;
  }

  getbacktohome(){
    return this.backtohome;
  }
  
  getvideoconnection(key){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    return this._http.get<any>('https://stream.adr.avileap.com:5443/LiveApp/rest/v2/broadcasts/' + key, {headers: headers})
  }
  
  Autosearchapi(param): Observable<any>{
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    let params = new HttpParams()
    params = params.set('gate', param);
    headers = headers.append('version', '2')
    return this._http.get<any>(this.host + "/ADR/autosuggest",{params: params, headers: headers});
  }

  clicksearchapi(param): Observable<any>{
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    let params = new HttpParams()
    params = params.set('gate', param);
    headers = headers.append('version', '2')
    return this._http.get<any>(this.host + "/ADR/searchinfolookup",{params: params, headers: headers});
  }

  getsession(param){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', '2')
    return this._http.post<any>(this.host + "/no-auth-pax-view-session",param,{headers: headers});
  }

  getallgates(){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    let params = new HttpParams()
    headers = headers.append('version', '2')
    return this._http.get<any>(this.host + "/ADR/peer-gates",{params: params, headers: headers});
  }

  watchcountapi(param){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', '2')
    return this._http.post<any>(this.host + "/pax/refresh-update ", param,{headers: headers});
  }

  setSharedData(data: any): void {
    this.sharedData = data;
  }

  getSharedData(): any {
    return this.sharedData;
  }

  seterrormessage(data){
    this.errormessage = data
  }

  geterrormessage(){
    return this.errormessage;
  }

  setsessionId(key: string, value: any, expiryInHours: number): void {
    const now = new Date();
    const expiryTime = now.getTime() + expiryInHours * 60 * 60 * 1000;
  
    const item = {
      value: value,
      expiry: expiryTime,
    };
  
    sessionStorage.setItem(key, JSON.stringify(item));
  }

  getsessionId(key:any){
    const itemString = sessionStorage.getItem(key);
    if (itemString) {
      const item = JSON.parse(itemString);
      if (item.expiry > Date.now()) {
        return item.value;
      } else {
        sessionStorage.removeItem(key);
        return null;
      }
    } else {
      return null;
    }
  }

  sendrating(param){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', '2')
    return this._http.post<any>(this.host + "/user-rating ", param,{headers: headers});
  }

  verifyapi(param) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', '2')
    return this._http.post<any>(this.host + "/verify-qr-session", param,{headers: headers});
  }

  getqrimage(param){
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    headers = headers.append('AUTHTYPE', 'COGNITO');
    headers = headers.append('version', '2')
    return this._http.post<any>(this.host + "/create-qr-code", param,{headers: headers});
  }
  
  
}
